import styled from "styled-components"

export const InputWrapper = styled.div`
display: flex;
margin-top: 1rem;

  svg {
    height: 4rem;
    margin-right: 1rem;
  }

`
